export function getAuthToken(): string | null {
  try {
    const raw = localStorage.getItem('xv_auth_token');
    if (!raw) return null;
    const token = raw.trim();
    return token ? token : null;
  } catch {
    return null;
  }
}

export function withAuthHeaders(headers: HeadersInit = {}): HeadersInit {
  const token = getAuthToken();
  if (!token) return headers;

  return {
    ...headers,
    Authorization: `Bearer ${token}`,
    'x-auth-token': token
  };
}
